import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<ol class=\"breadcrumb page-breadcrumb\"><li class=\"breadcrumb-item\"><a href=\"javascript:void(0);\">SmartAdmin</a></li><li class=\"breadcrumb-item\">Category</li><li class=\"breadcrumb-item\">Sub-category</li><li class=\"breadcrumb-item active\">Page Title</li><li class=\"position-absolute pos-top pos-right d-none d-sm-block\"><span class=\"js-get-date\"></span></li></ol><div class=\"subheader\"><h1 class=\"subheader-title\"><i class=\"subheader-icon fal fa-globe\"></i> Alerts <span class=\"fw-300\">サンプル</span><sup class=\"badge badge-primary fw-500\">STICKER</sup><small> Insert page description or punch line </small></h1><div class=\"subheader-block\">Right Subheader Block</div></div><div class=\"alert alert-primary\"><div class=\"d-flex flex-start w-100\"><div class=\"mr-2 hidden-md-down\"><span class=\"icon-stack icon-stack-lg\"><i class=\"base base-6 icon-stack-3x opacity-100 color-primary-500\"></i><i class=\"base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical\"></i><i class=\"ni ni-blog-read icon-stack-1x opacity-100 color-white\"></i></span></div><div class=\"d-flex flex-fill\"><div class=\"flex-fill\"><span class=\"h5\">注意事項!</span><p>パネル内に表示させる用のアラート</p><p class=\"m-0\"> Follow a slogal with a useful link or call to action <a href=\"#\" target=\"_blank\">Call to action &gt;&gt;</a></p></div></div></div></div>", 3)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-xl-6" }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "panel-1",
      class: "panel"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
        /*#__PURE__*/_createElementVNode("h2", null, [
          /*#__PURE__*/_createTextVNode(" Basic "),
          /*#__PURE__*/_createElementVNode("span", { class: "fw-300" }, [
            /*#__PURE__*/_createElementVNode("i", null, "Alerts")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-collapse",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Collapse"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-fullscreen",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Fullscreen"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-close",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Close"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "panel-container show" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "panel-content" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "demo-v-spacing" }, [
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-primary",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Heads up!"),
              /*#__PURE__*/_createTextVNode(" This alert needs your attention, but it's not super important. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-success",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Well Done!"),
              /*#__PURE__*/_createTextVNode(" You successfully read this important alert message. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-danger",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Oh snap!"),
              /*#__PURE__*/_createTextVNode(" Change a few things up and try submitting again. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-warning",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Holy guacamole!"),
              /*#__PURE__*/_createTextVNode(" You should check in on some of those fields below. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-info",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Info!"),
              /*#__PURE__*/_createTextVNode(" Alert for passing information to user. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-secondary",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Hello World!"),
              /*#__PURE__*/_createTextVNode(" This is default alert message box. ")
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      id: "panel-2",
      class: "panel"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
        /*#__PURE__*/_createElementVNode("h2", null, [
          /*#__PURE__*/_createTextVNode(" Dismissable "),
          /*#__PURE__*/_createElementVNode("span", { class: "fw-300" }, [
            /*#__PURE__*/_createElementVNode("i", null, "Alerts")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-collapse",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Collapse"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-fullscreen",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Fullscreen"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-close",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Close"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "panel-container show" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "panel-content" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "demo-v-spacing" }, [
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-primary alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
              ]),
              /*#__PURE__*/_createElementVNode("strong", null, "Heads up!"),
              /*#__PURE__*/_createTextVNode(" This alert needs your attention, but it's not super important. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-success alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("strong", null, "Well Done!"),
              /*#__PURE__*/_createTextVNode(" You successfully read this important alert message. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-danger alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-trash-alt" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("strong", null, "Oh snap!"),
              /*#__PURE__*/_createTextVNode(" Change a few things up and try submitting again. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-warning alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-square" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("strong", null, "Holy guacamole!"),
              /*#__PURE__*/_createTextVNode(" You should check in on some of those fields below. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-info alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("strong", null, "Info!"),
              /*#__PURE__*/_createTextVNode(" Alert for passing information to user. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-secondary alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-window-close" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("strong", null, "Hello World!"),
              /*#__PURE__*/_createTextVNode(" This is default alert message box. ")
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      id: "panel-3",
      class: "panel"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
        /*#__PURE__*/_createElementVNode("h2", null, [
          /*#__PURE__*/_createTextVNode(" Large "),
          /*#__PURE__*/_createElementVNode("span", { class: "fw-300" }, [
            /*#__PURE__*/_createElementVNode("i", null, "Alerts")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-collapse",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Collapse"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-fullscreen",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Fullscreen"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-close",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Close"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "panel-container show" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "panel-content" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "demo-v-spacing" }, [
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-success alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon width-1" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sync fs-xl fa-spin" })
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h6 m-0 fw-700" }, "Task 55% Complete"),
                  /*#__PURE__*/_createElementVNode("div", { class: "progress mt-1 progress-xs" }, [
                    /*#__PURE__*/_createElementVNode("div", {
                      class: "progress-bar progress-bar-striped progress-bar-animated bg-success-600",
                      role: "progressbar",
                      style: {"width":"55%"},
                      "aria-valuenow": "55",
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    })
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert bg-success-500 alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon width-1" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check fs-xl" })
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h6 m-0 fw-700" }, "Task 100% Complete"),
                  /*#__PURE__*/_createElementVNode("div", { class: "progress mt-1 progress-xs" }, [
                    /*#__PURE__*/_createElementVNode("div", {
                      class: "progress-bar progress-bar-striped bg-warning-500",
                      role: "progressbar",
                      style: {"width":"100%"},
                      "aria-valuenow": "100",
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    })
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert border-info bg-transparent text-info fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" })
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h5 m-0 fw-700" }, "Compilation error occured! ")
                ]),
                /*#__PURE__*/_createElementVNode("button", {
                  type: "button",
                  class: "btn btn-info btn-pills btn-sm btn-w-m mr-1 waves-effect waves-themed"
                }, " Repair "),
                /*#__PURE__*/_createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger btn-pills btn-sm btn-w-m waves-effect waves-themed",
                  "data-dismiss": "alert",
                  "aria-label": "Close"
                }, " Dismiss ")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert border-danger bg-transparent text-secondary fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-md" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "base-7 icon-stack-3x color-danger-900" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times icon-stack-1x text-white" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h5 color-danger-900" }, "This branch is out-of-date with the base branch ")
                ]),
                /*#__PURE__*/_createElementVNode("a", {
                  href: "#",
                  class: "btn btn-outline-danger btn-sm btn-w-m waves-effect waves-themed"
                }, "Report")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert border-faded bg-transparent text-secondary fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-md" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "base-7 icon-stack-3x color-success-600" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check icon-stack-1x text-white" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h5 color-success-600" }, "All checks have passed!"),
                  /*#__PURE__*/_createElementVNode("br"),
                  /*#__PURE__*/_createTextVNode(" 2 successful checks ")
                ]),
                /*#__PURE__*/_createElementVNode("a", {
                  href: "#",
                  class: "btn btn-outline-success btn-sm btn-w-m waves-effect waves-themed"
                }, "Review")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert bg-info-400 text-white fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" })
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "This branch is out-of-date with the base branch"),
                  /*#__PURE__*/_createElementVNode("br"),
                  /*#__PURE__*/_createTextVNode(" Some pipes failed during build. ")
                ]),
                /*#__PURE__*/_createElementVNode("a", {
                  href: "#",
                  class: "btn btn-warning btn-pills btn-sm width-8 waves-effect waves-themed"
                }, "Fix")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "alert bg-fusion-400 border-0 fade show" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-shield-check text-warning" })
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "Download complete"),
                  /*#__PURE__*/_createElementVNode("br"),
                  /*#__PURE__*/_createTextVNode(" Install the latest version of SmartAdmin WebApp ")
                ]),
                /*#__PURE__*/_createElementVNode("a", {
                  href: "#",
                  class: "btn btn-warning btn-w-m fw-500 btn-sm waves-effect waves-themed",
                  "data-dismiss": "alert",
                  "aria-label": "Close"
                }, "Install")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "alert bg-warning-500 alert-dismissible fade show" }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-sm" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "base-7 icon-stack-3x color-fusion-200" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "base-7 icon-stack-2x color-fusion-500" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "ni ni-graph icon-stack-1x text-white" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "Large Icon Stack"),
                  /*#__PURE__*/_createElementVNode("br"),
                  /*#__PURE__*/_createTextVNode(" Custom alert background with "),
                  /*#__PURE__*/_createElementVNode("strong", null, "large"),
                  /*#__PURE__*/_createTextVNode(" sized icon stack. ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-xl-6" }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "panel-4",
      class: "panel"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
        /*#__PURE__*/_createElementVNode("h2", null, [
          /*#__PURE__*/_createTextVNode(" Alert "),
          /*#__PURE__*/_createElementVNode("span", { class: "fw-300" }, [
            /*#__PURE__*/_createElementVNode("i", null, "Outline")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-collapse",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Collapse"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-fullscreen",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Fullscreen"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-close",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Close"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "panel-container show" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "panel-content" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "demo-v-spacing" }, [
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert border border-primary bg-transparent text-primary",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Heads up!"),
              /*#__PURE__*/_createTextVNode(" This alert needs your attention, but it's not super important. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert border-success bg-transparent text-success",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Well Done!"),
              /*#__PURE__*/_createTextVNode(" You successfully read this important alert message. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert border-danger bg-transparent text-danger",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Oh snap!"),
              /*#__PURE__*/_createTextVNode(" Change a few things up and try submitting again. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert border-warning bg-transparent color-warning-900",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Holy guacamole!"),
              /*#__PURE__*/_createTextVNode(" You should check in on some of those fields below. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert border-info bg-transparent text-info",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Info!"),
              /*#__PURE__*/_createTextVNode(" Alert for passing information to user. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert border-secondary bg-transparent text-secondary",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Hello World!"),
              /*#__PURE__*/_createTextVNode(" This is default alert message box. ")
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      id: "panel-5",
      class: "panel"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
        /*#__PURE__*/_createElementVNode("h2", null, [
          /*#__PURE__*/_createTextVNode(" Alternative "),
          /*#__PURE__*/_createElementVNode("span", { class: "fw-300" }, [
            /*#__PURE__*/_createElementVNode("i", null, "Backgrounds")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-collapse",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Collapse"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-fullscreen",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Fullscreen"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-close",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Close"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "panel-container show" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "panel-content" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "demo-v-spacing" }, [
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert bg-info-500",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Info!"),
              /*#__PURE__*/_createTextVNode(" Alert for passing information to user. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert bg-primary-200 text-white",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Heads up!"),
              /*#__PURE__*/_createTextVNode(" This alert needs your attention, but it's not super important. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert bg-danger-400 text-white",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Oh snap!"),
              /*#__PURE__*/_createTextVNode(" Change a few things up and try submitting again. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert bg-fusion-200 text-white",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Hello World!"),
              /*#__PURE__*/_createTextVNode(" This is default alert message box. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert bg-warning-700 text-white",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Holy guacamole!"),
              /*#__PURE__*/_createTextVNode(" You should check in on some of those fields below. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert bg-success-400 text-white",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("strong", null, " Well Done!"),
              /*#__PURE__*/_createTextVNode(" You successfully read this important alert message. ")
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      id: "panel-6",
      class: "panel"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
        /*#__PURE__*/_createElementVNode("h2", null, [
          /*#__PURE__*/_createTextVNode(" Stack "),
          /*#__PURE__*/_createElementVNode("span", { class: "fw-300" }, [
            /*#__PURE__*/_createElementVNode("i", null, "Icon")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-collapse",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Collapse"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-fullscreen",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Fullscreen"
          }),
          /*#__PURE__*/_createElementVNode("button", {
            class: "btn btn-panel waves-effect waves-themed",
            "data-action": "panel-close",
            "data-toggle": "tooltip",
            "data-offset": "0,10",
            "data-original-title": "Close"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "panel-container show" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "panel-content" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "demo-v-spacing" }, [
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-primary alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon width-2" }, [
                  /*#__PURE__*/_createElementVNode("span", {
                    class: "icon-stack",
                    style: {"font-size":"22px"}
                  }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "base-2 icon-stack-3x color-primary-400" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "ni md-profile color-primary-800 icon-stack-2x" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("strong", null, "Custom stack icon size! "),
                  /*#__PURE__*/_createTextVNode(" You can change the stack icon size with font-size style property. ")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert border-primary bg-transparent text-primary alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon width-2" }, [
                  /*#__PURE__*/_createElementVNode("span", {
                    class: "icon-stack",
                    style: {"font-size":"22px"}
                  }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "base-2 icon-stack-3x color-primary-400" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "ni md-profile color-primary-800 icon-stack-2x" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("strong", null, "Custom stack icon size! "),
                  /*#__PURE__*/_createTextVNode(" You can change the stack icon size with font-size style property. ")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-success alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon width-3" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-sm" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "base-2 icon-stack-3x color-success-600" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "ni md-profile color-success-800 icon-stack-2x" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h5 m-0 fw-700" }, "Small Icon Stack!"),
                  /*#__PURE__*/_createTextVNode(" Custom alert background with "),
                  /*#__PURE__*/_createElementVNode("strong", null, "small"),
                  /*#__PURE__*/_createTextVNode(" sized icon stack. ")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", {
              class: "alert alert-info alert-dismissible fade show",
              role: "alert"
            }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-md" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "base-2 icon-stack-3x color-info-400" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "ni md-profile color-info-800 icon-stack-2x" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h4" }, "Medim Icon Stack"),
                  /*#__PURE__*/_createElementVNode("br"),
                  /*#__PURE__*/_createTextVNode(" Custom alert background with "),
                  /*#__PURE__*/_createElementVNode("strong", null, "medium"),
                  /*#__PURE__*/_createTextVNode(" sized icon stack. ")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "alert alert-warning alert-dismissible fade show" }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon width-6" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "base-2 icon-stack-3x color-warning-400" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "ni md-profile color-warning-800 icon-stack-2x" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h3" }, "Large Icon Stack"),
                  /*#__PURE__*/_createElementVNode("br"),
                  /*#__PURE__*/_createTextVNode(" Custom alert background with "),
                  /*#__PURE__*/_createElementVNode("strong", null, "large"),
                  /*#__PURE__*/_createTextVNode(" sized icon stack. ")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "alert bg-danger-600 alert-dismissible fade show" }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon width-8" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-xl" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "base-2 icon-stack-3x color-danger-400" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "ni md-profile color-danger-800 icon-stack-2x" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1 pl-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h2" }, " Hold on there Sparky! "),
                  /*#__PURE__*/_createElementVNode("br"),
                  /*#__PURE__*/_createTextVNode(" Better fix those errors before you can complete this request ")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "alert alert-danger alert-dismissible fade show" }, [
              /*#__PURE__*/_createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close"
              }, [
                /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "alert-icon width-8" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-xl" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "base-2 icon-stack-3x color-danger-400" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                    /*#__PURE__*/_createElementVNode("i", { class: "ni md-profile color-danger-800 icon-stack-2x" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex-1 pl-1" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "h2" }, " Hold on there Sparky! "),
                  /*#__PURE__*/_createElementVNode("br"),
                  /*#__PURE__*/_createTextVNode(" Better fix those errors before you can complete this request ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, _hoisted_6))
}